import { Button } from '@timelyapp/react';
import { Close } from 'components/Icons';
import { ListColumn, ListRow } from 'components/ui-blocks/list';
import React, { PureComponent } from 'react';
import type { Team } from 'types/team';
import styles from './UserEditorTeam.module.scss';

interface Props {
  team: Team;
  onRemove?: (teamId: number) => void;
  disabled?: boolean;
}

export default class UserEditorTeam extends PureComponent<Props> {
  handleRemove = () => {
    if (!this.props.disabled && this.props.onRemove) {
      this.props.onRemove(this.props.team.id!);
    }
  };

  render() {
    const { team, disabled } = this.props;

    return (
      <ListRow>
        <ListColumn>
          <img src={team.emoji} alt={team.name} className={styles.emoji} />
        </ListColumn>
        <ListColumn autoGrow>
          <p>{team.name}</p>
        </ListColumn>
        {this.props.onRemove && (
          <ListColumn>
            <Button priority="low" onClick={this.handleRemove} disabled={disabled}>
              <Close />
            </Button>
          </ListColumn>
        )}
      </ListRow>
    );
  }
}
